import React, { forwardRef, useCallback, useContext, useEffect } from 'react';
// components
import Brushes, { BrushesRecievedProps } from './Brushes';
import { Reset } from './Reset';
import { RedoUndo } from './RedoUndo';
import Button from '@cube3/cubicle/src/core/atoms/Button/Button';
import { isMobile } from 'react-device-detect';
import { SizeVariants } from '@cube3/cubicle/src/theme/themes';
import { ReviewViewContext } from '../../../../main/src/components/app/layout/ReviewTool/Context/reviewViewContext';
import {
  ReviewAssetViewerContext,
  ReviewToolContext
} from '../../../../main/src/components/app/layout/ReviewTool/Context/reviewToolContext';

import { useModalActions } from '@cube3/state/src/redux/Hooks/useModalActions';
import MaybeTooltip from '@cube3/ui/src/Tooltip/MaybeTooltip';

interface Props extends BrushesRecievedProps {
  // sketchPad: SketchPad;
  onSave?: (svg) => void;
  closeDrawingBar: () => void;
}

// TODO: make it draggable?
const DrawingToolbar = React.memo(
  forwardRef<HTMLDivElement, Props>((props, ref) => {
    /**
     * TODO:
     * the toolbar design/styling will ultimately depend on how we choose to implement it within the Preview container
     */

    //add comment modal 

    const modalActions = useModalActions();
    const { activeAsset, reviewLink, email, userImage } =
      useContext(ReviewViewContext) || {};
    const {
      drawnSvg,
      player,
      activeTemplate,
      setDrawnSvg,
      setActiveComment,
      toggleDrawingBar
    } = useContext(ReviewToolContext) || {};
    const { timestamp } = useContext(ReviewAssetViewerContext) || {};

    const playing: boolean = false
    const drawingBarToggled: boolean = true;


    const handleSaveDraw = useCallback(() => {

      modalActions.openModal('reviewlink_addComment', {
        activeAsset, reviewLink, email, userImage,
        drawnSvg,
        drawingBarToggled,
        player,
        playing,
        activeTemplate,
        setDrawnSvg,
        setActiveComment,
        toggleDrawingBar,
        timestamp
      });

    }, [activeAsset, reviewLink, email, userImage,
      drawnSvg,
      drawingBarToggled,
      player,
      playing,
      activeTemplate,
      setDrawnSvg,
      setActiveComment,
      toggleDrawingBar
    ]);




    return (
      <>
        {isMobile ?
          <div
            ref={ref}
            style={{
              position: 'absolute',
              bottom: 16,
              left: '50%',
              transform: 'translateX(-50%)',
              padding: '8px 12px',
              borderRadius: 16,
              background: 'rgb(28, 28, 28)',
              display: 'flex',
              flexDirection: 'column',
              width: 'calc(100% - 50px)',
              border: '1px solid rgba(255,255,255,0.04)',
              gap: '12px'
            }}
            data-pw="drawing-tool-bar"
          >
            <Brushes {...props} />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ display: 'flex', }}>
                <RedoUndo type={'undo'} onSave={props.onSave} />
                <RedoUndo type={'redo'} onSave={props.onSave} /> <Reset onSave={props.onSave} />
              </span>
              <span style={{ display: 'flex' }}>
                <Button
                  label="Cancel"
                  background="secondary"
                  buttonStyle="ghost"
                  onClick={props.closeDrawingBar}
                  size={SizeVariants.lg}
                />
                <Button
                  label="Save..."
                  background="primary"
                  buttonStyle="solid"
                  onClick={handleSaveDraw}
                  size={SizeVariants.lg}
                  disabled={drawnSvg === undefined || drawnSvg === '' || drawnSvg.includes('undefined') ? true : false}
                />
              </span>
            </div>
          </div>
          :
          <div
            ref={ref}
            style={{
              position: 'absolute',
              bottom: 16,
              left: '50%',
              transform: 'translateX(-50%)',
              padding: '8px 8px',
              borderRadius: 16,
              background: 'rgb(28, 28, 28)', // theme.color.background.neutral
              display: 'flex',
              flexWrap: 'nowrap',
              alignItems: 'center',
              border: '1px solid rgba(255,255,255,0.04)',
              gap: '12px'
            }}
            data-pw="drawing-tool-bar"
          >
            <RedoUndo type={'undo'} onSave={props.onSave} />
            <RedoUndo type={'redo'} onSave={props.onSave} />
            <Brushes {...props} />
            <Reset onSave={props.onSave} />
            <Button
              label="Cancel"
              iconRight="close"
              background="secondary"
              buttonStyle="ghost"
              onClick={props.closeDrawingBar}
            />
            <MaybeTooltip title="Save drawing">
              <Button
                label="Save..."
                background="primary"
                buttonStyle="solid"
                onClick={handleSaveDraw}
                //if svg gets cleaned or does not exit disable save
                disabled={drawnSvg === undefined || drawnSvg === '' || drawnSvg.includes('undefined') ? true : false}
              />
            </MaybeTooltip>
          </div>}
      </>
    );
  })
);

export default DrawingToolbar;
